ControlBinders.register(`[data-cta-bar]`, () => document.querySelector("body").classList.add("has-cta-bar"));
